import { render, staticRenderFns } from "./VoteComponent.vue?vue&type=template&id=38374f7a&scoped=true&"
import script from "./VoteComponent.vue?vue&type=script&lang=js&"
export * from "./VoteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38374f7a",
  null
  
)

export default component.exports